/* Flaire: load the "second photo" that shows when you hover a product card only when someone actually hovers (or
   keyboard-focuses) that card. Before this, every card downloaded its hover photo up front: on the Sale page that was
   about 6.5 MB of hidden images (avg 118 KB each) next to 1.4 MB of visible ones, and phones, which never hover, paid for
   them too. The markup (snippets/product--item.liquid and sections/flaire-collection-row.liquid) renders the hover <img>
   without a src and keeps the real address in data-fhi-src / data-fhi-srcset; this script copies them over. */
(function () {
  if (window.__flaireHoverImages) { return; }
  window.__flaireHoverImages = true;

  function hydrate(card) {
    var img = card.querySelector('img[data-fhi-src]');
    if (!img) { return; }
    var set = img.getAttribute('data-fhi-srcset');
    if (set) { img.setAttribute('srcset', set); }
    img.setAttribute('src', img.getAttribute('data-fhi-src'));
    img.removeAttribute('data-fhi-src');
    img.removeAttribute('data-fhi-srcset');
  }

  function find(e) {
    var t = e.target;
    return t && t.closest ? t.closest('[data-hover-image], .fcr__card') : null;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') { return; }
    var card = find(e);
    if (card) { hydrate(card); }
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    var card = find(e);
    if (card) { hydrate(card); }
  });
})();